export const ENVIRONMENTS = ['qa', 'pre-qa', 'qax', 'pre-qax', 'qae', 'pre-qae', 'pre-uat1', 'uat1', 'pre-sit', 'sit', 'pre', 'sim', 'pre-sim', 'prod']

export function getEnvironmentName(origin) {
  const hostre = /^(?:\w+:\/\/)?(?:(loginas|origin|ips)(?:-))?(\b(?:[a-z][a-z]|dev)\b)?(?:(?:-)?((?:pre-)?\w+)?)?(?:\.ips)?(?:\.(localwebdev|[a-z]+-webdev|[a-z]+-webreview))?(?:\.insight\.com)?$/
  const hostparts = hostre.exec(origin);

  /* 
    This check is nessesary because 'projectqa-loginas' does not follow a consistent naming
    convention, and will not return 'qa' as it should. 
  */
  if (!hostparts && /\bprojectqa\b/.test( origin )) return "qa"; 

  if (!hostparts) return 'prod'; // prod will  be failsafe

  if (hostparts[3] === 'localhost' || hostparts[4] !== undefined) {
    return process.env.REACT_APP_ENVIRONMENT || 'localhost';
  }

  const env = hostparts && hostparts[3] || 'prod';

  if (env==='projectqa') return 'qa';
  if (env==='www') return 'prod';
  return validateEnv(env) ? env : 'prod' // prod will be failsafe
}

function validateEnv(env) {
  return ENVIRONMENTS.includes(env)
}
